import { observer } from 'mobx-react-lite';
import { Search, SearchProps } from '@wix/design-system';
import React, { CSSProperties } from 'react';
import { CollectionStateProps } from './collectionStateProps';
import { FiltersMap } from '@wix/bex-core';

export interface CollectionSearchProps<T, F extends FiltersMap>
  extends CollectionStateProps<T, F>,
    Partial<SearchProps> {
  onSearchChange?: (value: string) => unknown;
  onSearchClick?: () => unknown;
  onSearchBlur?: (value: string) => unknown;
  visibility?: CSSProperties['visibility'];
}

export const CollectionSearch = observer(function CollectionSearch<
  T,
  F extends FiltersMap = FiltersMap,
>({
  state,
  onSearchChange,
  onSearchClick,
  onSearchBlur,
  visibility,
  ...rest
}: CollectionSearchProps<T, F>) {
  const {
    query: { search },
    translate: t,
  } = state;

  return (
    <Search
      dataHook="collection-search"
      onChange={(e) => {
        const value = e.target.value;
        state.search(e.target.value, { clearResult: true });
        onSearchChange?.(value);
      }}
      value={search.value}
      onClear={() => {
        const value = '';
        state.clearSearch();
        onSearchChange?.(value);
      }}
      placeholder={t('cairo.searchPlaceholder')}
      onInputClicked={() => onSearchClick?.()}
      onBlur={(e) => {
        const value = e.target.value;
        onSearchBlur?.(value);
      }}
      {...rest}
    />
  );
});
